import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import classnames from "classnames";
import { FontAwesomeIcon } from "./FontAwesomeIcon";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { DoraCheckbox } from "./DoraCheckbox";
import "./DoraSelect.scss";
import { useRef } from "react";
export const DoraSelectMultiple = (props) => {
    const { id, options, selectableOptions, loading, loadingText, selectedValues, controlField, customRenderOption, customRenderValue, limitTags, placeholder, maxSelections, disabled, error, className, label, } = props;
    const allViewableOptions = selectableOptions || options;
    const valueIdsKey = controlField?.value?.map((v) => v.id).join(",") ?? "";
    const stableValueRef = useRef({ key: "", value: [] });
    if (stableValueRef.current.key !== valueIdsKey) {
        stableValueRef.current = {
            key: valueIdsKey,
            value: controlField?.value?.length
                ? controlField.value.map((v) => {
                    return (allViewableOptions.find((o) => o.id === v.id) ??
                        options.find((o) => o.id === v.id) ??
                        v);
                })
                : controlField?.value ?? [],
        };
    }
    const useFormsValueProp = controlField
        ? { value: stableValueRef.current.value }
        : {};
    const defaultRenderOption = (props, option, { selected }) => (_createElement("li", { ...props, key: option.id },
        _jsx(DoraCheckbox, { checked: selected, style: { marginRight: 8 } }),
        option.label));
    const wrapperClasses = classnames("dora-select__wrapper", disabled ? "dora-select__wrapper--disabled" : null, error ? "dora-select__wrapper--error" : null, className);
    const currentCount = controlField?.value?.length ?? 0;
    const maxReached = typeof maxSelections === "number" && currentCount >= maxSelections;
    const inputRef = useRef(null);
    const onAdornmentClick = () => {
        if (props.disabled)
            return;
        inputRef.current?.focus();
    };
    return (_jsx("div", { className: wrapperClasses, children: _jsx(Autocomplete, { multiple: true, size: "small", openOnFocus: true, disabled: disabled, options: allViewableOptions, loading: controlField?.loading || loading, loadingText: loadingText, ...(selectedValues && { value: selectedValues }), getOptionDisabled: () => !!maxSelections && maxReached, isOptionEqualToValue: (option, value) => option.id === value.id, ...(id && { id }), ...useFormsValueProp, ...(limitTags && { limitTags }), disableCloseOnSelect: true, selectOnFocus: true, autoHighlight: true, handleHomeEndKeys: true, slotProps: {
                popper: {
                    sx: {
                        minWidth: "fit-content",
                    },
                },
            }, sx: {
                margin: 0,
                background: disabled ? "var(--gray-100)" : "white",
                "& input::placeholder": {
                    color: "var(--gray-800)",
                    fontWeight: 400,
                },
                "& fieldset": { borderColor: "var(--gray-300)" },
                "& .MuiOutlinedInput-root:not(.Mui-focused):hover fieldset": {
                    borderColor: "var(--gray-400) !important",
                },
                ...(!disabled && { "&:hover": { borderColor: "var(--gray-300)" } }),
                "& .MuiFormControl-root.MuiFormControl-marginDense.MuiFormControl-fullWidth.MuiTextField-root": {
                    margin: "0 !important",
                },
                "& .MuiOutlinedInput-root": { paddingRight: "25px !important" },
            }, renderOption: customRenderOption || defaultRenderOption, ...(customRenderValue && { renderValue: customRenderValue }), onChange: controlField
                ? (_, option) => {
                    controlField.onChange(option);
                }
                : (_, option) => props.onChange(option.map((selected) => selected.id)), renderInput: (params) => (_jsx(TextField, { ...params, label: label, placeholder: placeholder, margin: "dense", inputRef: inputRef, InputProps: {
                    ...params.InputProps,
                    endAdornment: (_jsx("div", { className: "dora-select__caret", children: _jsx(FontAwesomeIcon, { icon: faAngleDown, onClick: onAdornmentClick }) })),
                }, size: "small" })) }) }));
};
export const UFDoraSelectMultiple = (props) => {
    const { error, name, maxSelections, control, options, selectableOptions, customRenderOption, customRenderValue, } = props;
    return (_jsx(Controller, { control: control, render: ({ field }) => (_jsx(DoraSelectMultiple, { error: error, maxSelections: maxSelections, placeholder: props.placeholder, className: props.className, disabled: props.disabled, id: props.id, options: options, selectableOptions: selectableOptions, controlField: field, customRenderOption: customRenderOption, customRenderValue: customRenderValue })), name: name }));
};
//# sourceMappingURL=DoraSelectMultiple.js.map